import React, { useRef, useState } from "react";
import { Steps, type StepsRef } from "@design-system/Steps";
import type { Step } from "@design-system/Steps/types";
import { SelectControl } from "./playgroundControls";
import { SandboxLayout } from "./SandboxLayout";
import { ShowcasePreview } from "./ShowcasePreview";
import styles from "./structureLayoutControls.module.scss";

const stepIds = ["details", "accounts", "review"] as const;
type StepId = (typeof stepIds)[number];

const steps = [
    {
        id: "details",
        header: "Details",
        content: (
            <div className={styles.contentBlock}>
                <h3>Business details</h3>
                <p>Add the information needed to set up the workspace.</p>
            </div>
        ),
    },
    {
        id: "accounts",
        header: "Accounts",
        content: (
            <div className={styles.contentBlock}>
                <h3>Connect accounts</h3>
                <p>Choose which financial accounts to bring into Kick.</p>
            </div>
        ),
    },
    {
        id: "review",
        header: "Review",
        content: (
            <div className={styles.contentBlock}>
                <h3>Review setup</h3>
                <p>Confirm the details before finishing the flow.</p>
            </div>
        ),
    },
] satisfies Array<Step<StepId>>;

export const StepsPlayground = () => {
    const [currentStep, setCurrentStep] = useState<StepId>("accounts");
    const stepsRef = useRef<StepsRef>(null);

    return (
        <SandboxLayout
            controls={
                <section>
                    <h2>Current step</h2>
                    <div className={styles.fields}>
                        <SelectControl
                            label="Step"
                            options={stepIds}
                            value={currentStep}
                            onChange={setCurrentStep}
                        />
                    </div>
                </section>
            }
        >
            <ShowcasePreview
                summary={`${currentStep} · completed and upcoming states`}
                width="wide"
                output={JSON.stringify(
                    {
                        componentProps: {
                            defaultStep: currentStep,
                            steps: stepIds,
                        },
                        showcaseState: { currentStep },
                    },
                    null,
                    2,
                )}
            >
                <div className={styles.surface}>
                    <Steps
                        key={currentStep}
                        steps={steps}
                        defaultStep={currentStep}
                        stepsRef={stepsRef}
                        onStepChange={setCurrentStep}
                    />
                </div>
            </ShowcasePreview>
        </SandboxLayout>
    );
};
